import { Trans } from 'react-i18next';

// Import styles
import { StyledCloseButton, StyledText, ButtonWrapper } from './styles';

// Import assets
import { ReactComponent as CloseIcon } from 'assets/icons/modal_ic_close.svg';

type Props = {
	closeModal: VoidFunction;
	withPadding?: boolean;
};

export const ModalCloseButton = ({ closeModal, withPadding = false }: Props) => (
	<ButtonWrapper withPadding={withPadding}>
		<StyledCloseButton onClick={closeModal} variant="secondary" modifiers="text" icon={<CloseIcon />}>
			<StyledText>
				<Trans ns="dictionary" i18nKey="common_button_close" />
			</StyledText>
		</StyledCloseButton>
	</ButtonWrapper>
);
